import { TIER } from 'utilsTS/dom';
import defaultWidths from 'gds-styles/_container-widths.scss';

export const getContainerWidths = (
    widths: Record<string, string> = defaultWidths,
    widthPrefix = '',
): Record<TIER, number> => {
    const entries = Object.entries(TIER).map(([, value]) => {
        const styleKey = `${widthPrefix}${value}`;
        const tierWidth = Number.parseInt(widths[styleKey], 10) || 0;

        return [value, tierWidth];
    });

    return Object.fromEntries(entries);
};
